import { createReduxStore } from '#packages/apilib';
import type { MigrationPromise } from './types';

export interface MigrationsManagerStore {}

export interface MigrationsManagerState {
  migrationsQueue: MigrationPromise<unknown>[];
  isRunning: boolean;
}

const getInitialState = (): MigrationsManagerState => ({
  migrationsQueue: [],
  isRunning: false,
});

export const MigrationsManagerStore = createReduxStore({
  getInitialState,
  selectors: {
    getMigrationsQueue: ({ migrationsQueue }: MigrationsManagerState) =>
      migrationsQueue,
    getIsRunning: ({ isRunning }: MigrationsManagerState) => isRunning,
  },
  actions: {
    pushMigrationPromiseToQueue: <T>(
      state: MigrationsManagerState,
      migration: MigrationPromise<T>,
    ) => {
      return {
        ...state,
        migrationsQueue: [...state.migrationsQueue, migration],
      };
    },
    removeMigrationFromQueue: (state: MigrationsManagerState) => {
      return {
        ...state,
        migrationsQueue: state.migrationsQueue.slice(1),
      };
    },
    setIsRunning: (state: MigrationsManagerState, isRunning: boolean) => {
      return {
        ...state,
        isRunning,
      };
    },
  },
});
